import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  getAuthState,
  getAuthClaims,
  getAuthOptions,
} from "@redriver/cinnamon";
import { Login } from "features/System";
import { AppRoutes } from "constants/routes";
import { SystemPageContent } from "components/pages";

const LoginPage = ({
  loggedIn,
  emailVerified,
  useEmailVerification,
  location,
}) => {
  if (loggedIn && (emailVerified || !useEmailVerification)) {
    const nextRoute =
      location.state && location.state.nextPath
        ? location.state.nextPath
        : AppRoutes.Root;
    return <Redirect to={nextRoute} />;
  }

  return (
    <SystemPageContent>
      <Login />
    </SystemPageContent>
  );
};

const mapStateToProps = (state) => {
  const { loggedIn } = getAuthState(state);
  const { emailVerified } = getAuthClaims(state);
  const { useEmailVerification } = getAuthOptions();
  return {
    loggedIn,
    emailVerified,
    useEmailVerification,
  };
};

export default connect(mapStateToProps)(LoginPage);
